import { getCachedData } from "api/Cache";
import EventsEmitter from "events/EventsEmitter";
import { sortArrayByProp, sortArrayByPropValue, uniqueArray } from "services/UtilsService";

export default class FoldersActions {
    static foldersTree: any;
    static catalog: any;
    static filter: string = "";
    static selectedItems: any = [];
    static allEntities: any = [];
    static allCatalogs: any = [];
    static assigned: boolean = false;
    static showVirtuals: boolean = false;
    static cachedData: any = getCachedData();

    static setCachedData(data: any) {
        FoldersActions.cachedData = JSON.parse(JSON.stringify(data));
    }

    static foreachEntity(entityList: any, type: string, fn: any) {
        for (let i in entityList) {
            var entity = entityList[i];
            if (entity.type === type) {
                fn(entity);
            }
        }
    }

    static reloadCatalog(callback: any) {
        this.assigned = false;
        this.buildFolderTree("all", "0", (foldersTree: any) => {
            FoldersActions.foldersTree = foldersTree;
            FoldersActions.assigned = true;
            EventsEmitter.emit("reloadCatalog", "");
            callback();
        });
    }

    static buildFolderTree(filter: string, catalogId: string, callback: any) {
        const data: any = FoldersActions.cachedData;// getCachedData();
        const { showVirtuals } = FoldersActions;
        const { views } = data;

        if (catalogId && catalogId !== "0" && views[catalogId] && FoldersActions.filter === filter) {
            const view = views[catalogId];
            FoldersActions.allEntities[catalogId] = view;
            FoldersActions.allCatalogs[catalogId] = view;
            callback(view);
            return view;
        }
        if (FoldersActions.assigned && FoldersActions.filter === filter) {
            callback(FoldersActions.foldersTree);
            return;
        }
        const workerService = new Worker(new URL("workers/FoldersWorker", import.meta.url));
        workerService.onmessage = (message: any) => {
            if (message) {
                const data = message.data;
                const { folderTree, allEntities, allCatalogs } = data;
                //console.log("Message from worker", message.data);
                FoldersActions.allEntities = allEntities;
                FoldersActions.allCatalogs = allCatalogs;
                FoldersActions.foldersTree = folderTree;
                FoldersActions.filter = filter;
                FoldersActions.assigned = true;
                console.log("FoldersAction.folderTree:", folderTree);
                workerService.terminate();
                callback(folderTree);
            }
        };
        workerService.postMessage({ ...data, filter: filter, catalogId: catalogId, showVirtuals });
    }

    static getContainerFolder(projectId: string, itemId: string) {
        var entities: any = FoldersActions.cachedData.entities[projectId]//getCachedData("entities")[projectId];
        if (entities[itemId]) {
            return entities[itemId]["file_folder"];
        }
        return "0";
    }

    static listFolderItems(folder: any, type: string, sort?: boolean) {
        if (!folder.files) {
            return;
        }
        var list: any = [];

        const filterFunc = (entity: any) => {
            return entity.file_type && entity.name && typeof entity.file_date !== "undefined";
        };
        const filterView = (entity: any) => {
            return (entity.file_type === "VIEW" && entity.view_type === "container") || entity.file_type !== "VIEW";
        };
        const getFiles = (curFolder: any) => {
            var files = curFolder.files;
            files = files.filter(filterFunc);
            if (!FoldersActions.showVirtuals) {
                files = files.filter(filterView);
            }

            for (var j in files) {
                list = list.concat(files[j]);
            }
        };
        const addToList = (folder: any) => {
            list = list.concat(folder);
        };

        const getFolders = (curFolder: any) => {
            var subFolders = curFolder.subfolders;
            for (var i in subFolders) {
                var subFolder = subFolders[i];
                if (!subFolder.ID) {
                    continue;
                }
                if (subFolder.name === "Project Contents") {
                    subFolder.subfolders.forEach((folder: any) => {
                        addToList(folder);
                    });
                } else if (subFolder.parent && subFolder.parent.ID === curFolder.ID) {
                    addToList(subFolder);
                }
                if (
                    subFolder.subfolders &&
                    subFolder.entity &&
                    subFolder.entity.type === "PROJECT" &&
                    Object.values(subFolder.subfolders).length > 0 &&
                    subFolder.subfolders["0"].name === "Project Contents"
                ) {
                    //for projects
                    addToList(subFolder);
                }
            }
        };

        const getList = (curFolder: any) => {
            if (curFolder.subfolders) {
                getFolders(curFolder);
            }
            if (curFolder.files && folder.ID !== "0" && type !== "projects") {
                getFiles(curFolder);
            }
        };
        getList(folder);

        list = sortArrayByProp(list, "file_date", false);
        list = sortArrayByPropValue(list, "file_type", "VIEW");
        list = sortArrayByPropValue(list, "file_type", "FOLDER");
        if (sort) {
            list = sortArrayByProp(list, "name", false);
        }
        return list;
    }

    static getCatalog(catalogId: string, notAssign?: boolean) {
        let catalog;
        if (catalogId === "0") {
            if (FoldersActions.foldersTree) {
                catalog = FoldersActions.foldersTree[0];
            }
        } else {
            let entity: any;

            entity = FoldersActions.allEntities.find((entity: any) => entity.ID === catalogId);

            if (entity) {
                let type = entity.type;
                if (type === "PROJECT") {
                    if (FoldersActions.foldersTree) {
                        let projects: any = FoldersActions.foldersTree[0].subfolders;
                        catalog = projects[catalogId];
                    }
                } else {
                    catalog = FoldersActions.allCatalogs[catalogId];
                }
            }
        }
        if (!notAssign) {
            FoldersActions.catalog = catalog;
        }
        //console.log("catalog:", catalog);
        return catalog;
    }

    static getPath(catalog?: any) {
        var path: any = [];
        if (!catalog) {
            catalog = FoldersActions.catalog;
        }
        var getPath = (curCatalog: any) => {
            if (curCatalog) {
                var parent = curCatalog;
                do {
                    path.push(parent);
                    if (parent.file_type !== "FOLDER" && parent.file_type !== "PROJECT") {
                        parent = this.getCatalog(parent.file_folder, true);
                    } else {
                        parent = parent.parent;
                    }
                } while (parent && parent.name !== "Project Contents");
                if (
                    typeof curCatalog.project !== "undefined" ||
                    (curCatalog.entity && typeof curCatalog.entity.project !== "undefined")
                ) {
                    var projectId = curCatalog.project || (curCatalog.entity && curCatalog.entity.project);

                    var project = FoldersActions.getCatalog(projectId, true);
                    if (project && !path.includes(project)) {
                        path.push(project);
                    }
                }
            }
        };
        getPath(catalog);
        path = path.reverse();
        return path;
    }

    static getPathFromRoot(catalog: any[], fileName: any) {
        let strPath = "";
        this.getPath(catalog).forEach((path: any, index: number) => {
            if (index > 0 && path.name !== "Root" && path.name !== fileName) {
                strPath += `/${path.name}`;
            }
        });
        return `${strPath}/`;
    }

    static getPathFromEntity(entity: any) {
        var strPath = "/";
        var path: any = [];
        if (!entity || entity === null) {
            return path;
        }
        const projectId: string = entity["project"];
        if (!projectId) {
            return path;
        }
        var entities: any = FoldersActions.cachedData.entities[projectId];//getCachedData("entities")[projectId];
        const getPath = (curEntity: any) => {
            var folder = curEntity["file_folder"];
            if (folder && folder !== "0") {
                var parent = entities[folder];
                if (parent) {
                    path.push(parent["name"] + "/");
                    getPath(parent);
                }
            }
        };
        getPath(entity);
        strPath = "/" + path.reverse().join("");
        return strPath;
    }

    static getCatalogEntity = (catalog: any) => {
        if (catalog && catalog.entity) {
            return catalog.entity;
        }
        if (catalog["type"] === "FILE") {
            return catalog;
        }
        return undefined;
    };

    static getVirtuals(catalog: any) {
        const projectId = catalog["project"];
        let virtuals: any = [];
        const entities: any = FoldersActions.cachedData.entities[projectId];//getCachedData("entities")[projectId];
        const catalogEntity: any = this.getCatalogEntity(catalog);
        if (catalogEntity && catalogEntity["file_type"] === "FOLDER") {
            //get all virtuals of the current project
            const allVirtuals: any = Object.values(entities).filter((entity: any) => entity["virtual"] === "1");
            virtuals = allVirtuals.filter(
                (object: any) => object["file_folder"] === catalog["ID"] && object["file_type"] === "VIEW"
            );
        }
        return virtuals;
    }

    static getWorkflowFromEntity(entity: any) {
        var path: any = [],
            products: any = [];
        var version;
        var workflow = null;
        var comment;
        const projectId: string = entity["project"];
        if (!projectId) {
            return path;
        }
        var entities: any = FoldersActions.cachedData.entities[projectId];//getCachedData("entities")[projectId];
        const getWorkflow = (curEntity: any) => {
            if (curEntity) {
                var folder = curEntity["file_folder"];
                if (folder && folder !== "0") {
                    var parent = entities[folder];
                    if (parent) {
                        path.push(parent["name"]);
                        if (parent["version_number"]) {
                            version = parent["version_number"];
                            comment = parent["comment"];
                        } else if (parent["workflow_product"]) {
                            products.push(parent["name"]);
                        }
                        getWorkflow(parent);
                    }
                }
            }
        };

        getWorkflow(entity);
        if (version && products.length) {
            workflow = {
                version,
                comment,
                products: products.reverse(),
            };
        }
        return workflow;
    }

    static getEntityWorkflow(object: any) {
        if (object === null || undefined) {
            return;
        }
        var workflow;
        var folder = object["file_folder"];
        const projectId = object["project"];
        var entities: any = FoldersActions.cachedData.entities[projectId]; //getCachedData("entities")[projectId];
        if (folder && entities) {
            var parent = entities[folder];
            if (parent) {
                workflow = parent["workflow_product"];
            }
        }
        return workflow;
    }

    static getReportHierarchy(folder: any) {
        var nodes = [];
        for (var i in (folder?.subfolders || {})) {
            var subFolder: any = folder.subfolders[i];
            var parent: any = subFolder["parent"];
            var subNodes: any = [];
            if (!parent || (parent && subFolder["ID"] !== parent["ID"])) {
                subNodes = this.getReportHierarchy(subFolder);
            }
            if (subFolder.name && subNodes.length > 0) {
                nodes.push({
                    ID: subFolder.ID,
                    name: subFolder.name,
                    date: subFolder.file_date,
                    subFolders: subNodes,
                    type: folder.name === "Root" ? "PROJECT" : "FOLDER",
                });
            }
        }
        for (var j in (folder?.files || {})) {
            var file = folder.files[j];
            if (file.file_type === "REPORT") {
                nodes.push({
                    ID: file.ID,
                    name: file.name,
                    date: file.file_date,
                    project: file.project,
                });
            }
        }
        return nodes;
    }

    static getDataTypes(catalogId: string) {
        var types: any = [];
        var { catalog } = FoldersActions;
        var getTypes = (curCatalog: any) => {
            if (curCatalog) {
                if (
                    typeof curCatalog.project !== "undefined" ||
                    (curCatalog.entity && typeof curCatalog.entity.project !== "undefined")
                ) {
                    var projectId = curCatalog.project || (curCatalog.entity && curCatalog.entity.project);
                    var entities = FoldersActions.cachedData.entities[projectId]; //getCachedData("entities")[projectId];
                    types = Object.values(entities).filter((entity: any) => entity.virtual === "1");
                }
                if (
                    curCatalog.entity &&
                    typeof curCatalog.entity.file_folder !== "undefined" &&
                    curCatalog.entity.file_folder !== "0"
                ) {
                    var fileFolder = curCatalog.file_folder || curCatalog.entity.file_folder;
                    var folder: any = FoldersActions.getCatalog(fileFolder, true);
                    if (folder) {
                        if (folder.parent && folder.parent.name !== "Project Contents") {
                            getTypes(folder);
                        }
                    }
                }

                if (typeof curCatalog.file_folder !== "undefined") {
                    var newfolder: any = FoldersActions.getCatalog(curCatalog.file_folder, true);
                    if (newfolder) {
                        if (newfolder.parent && newfolder.parent.name !== "Project Contents") {
                            getTypes(newfolder);
                        }
                    }
                }
            }
        };
        getTypes(catalog);
        types = uniqueArray(types);
        return types;
    }
    static getWorkflow(catalog: any) {
        var path: any = [],
            products: any = [];
        var version;
        var workflow = null;
        const getWorkflow = (curCatalog: any) => {
            if (curCatalog) {
                path.push(curCatalog);
                if (curCatalog.entity) {
                    if (curCatalog.entity["version_number"]) {
                        version = curCatalog.entity["version_number"];
                    } else if (curCatalog.entity["workflow_product"]) {
                        products.push(curCatalog.entity["name"]);
                    }
                }
                if (curCatalog.file_type !== "FOLDER" && curCatalog.file_type !== "PROJECT") {
                    curCatalog = this.getCatalog(curCatalog.file_folder, true);
                } else {
                    curCatalog = curCatalog.parent;
                }
                getWorkflow(curCatalog);
            }
        };

        getWorkflow(catalog);
        if (version && products.length) {
            workflow = {
                version: version,
                products: products.reverse(),
            };
        }
        return workflow;
    }
}
